import { useContext } from "react";
import { AccrualMatchViewCtx } from "./accrualMatchView.context";

export function useAccrualMatchView() {
    return useContext(AccrualMatchViewCtx);
}
